export default __webpack_public_path__ + "static/media/left-arrow.c8e65279.svg";